import { Instance, types } from 'mobx-state-tree';

import mandatoryId from 'utils/store/mandatoryId';

export const StatusEnum = types.enumeration([
  'needs_to_run',
  'running',
  'done',
  'failed'
]);
export type FireTaskStatus = Instance<typeof StatusEnum>;

export const fireTaskTypeOptions = [
  'generate_briefing',
  'generate_painpoints',
  'generate_benchmarks',
  'generate_hypotheses'
  
];
export const FireTaskTypeEnum = types.enumeration(fireTaskTypeOptions);
export type FireTaskType = Instance<typeof FireTaskTypeEnum>;

export const FireTaskModel = types.model('FireTaskModel', {
  id: types.identifierNumber,
  task_type: types.maybe(FireTaskTypeEnum),
  status: types.maybe(StatusEnum),
  position: types.maybe(types.number),
});

export const createFireTaskModel = (data?: any): FireTaskModelType | undefined => {
  if (!data) {
    return undefined;
  }

  return FireTaskModel.create({
    id: mandatoryId(data?.id),
    task_type: data?.task_type ? FireTaskTypeEnum.create(data.task_type) : undefined,
    status: data?.status ? StatusEnum.create(data.status) : undefined,
    position: data?.position
  });
};

export type FireTaskModelType = typeof FireTaskModel.Type;
export default FireTaskModel;
